/** Detecta PWA instalada / viewport estrecho para arranque y Firestore. */

export const GOOGLE_REDIRECT_FLAG = 'nexus_google_redirect';

export function isStandaloneDisplay() {
  if (typeof window === 'undefined') return false;
  try {
    return (
      window.matchMedia('(display-mode: standalone)').matches
      || window.matchMedia('(display-mode: fullscreen)').matches
      || window.matchMedia('(display-mode: minimal-ui)').matches
      || window.navigator.standalone === true
    );
  } catch (_) {
    return false;
  }
}

function isMobileUserAgent() {
  if (typeof window === 'undefined') return false;
  return /Android|iPhone|iPad|iPod/i.test(window.navigator?.userAgent || '');
}

export function isNexusLocalHost() {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

/**
 * Chrome, Edge y la app instalada. El canal de Firestore por HTTP/3 se queda
 * mudo y getDocs no responde. Safari no trae "Chrome/" en el user agent.
 */
export function isChromiumBrowser() {
  if (typeof navigator === 'undefined') return false;
  return /Chrome\//.test(navigator.userAgent || '');
}

/**
 * En localhost el caché persistente de Firestore se traba con HMR, DevTools
 * y otra pestaña de Nexus. Memoria evita el lock de IndexedDB.
 */
export function shouldUseEphemeralLocalFirebase() {
  return isNexusLocalHost();
}

export function isMobileNexusViewport() {
  if (typeof window === 'undefined') return false;
  try {
    if (window.matchMedia('(max-width: 1023px)').matches) return true;
  } catch (_) {
    /* ignore */
  }
  return isMobileUserAgent();
}

/**
 * PWA instalada o teléfono de verdad.
 * No uses el ancho del viewport: DevTools a un lado en escritorio deja <1024px
 * y persistentSingleTabManager traba Firestore si hay otra pestaña de Nexus.
 */
export function shouldUseSingleTabFirestore() {
  return isStandaloneDisplay() || isMobileUserAgent();
}

/** PWA instalada: IndexedDB de Auth tarda; no pintar login oscuro a los 150ms. */
export function loginFallbackDelayMs() {
  return isStandaloneDisplay() ? 1500 : 400;
}

/**
 * Sesión staff ya confirmada. Un `null` de Auth a mitad de uso suele ser
 * refresh del token o IndexedDB trabado, no un cierre real.
 * authStateReady ya resolvió en el arranque y no cubre este caso.
 */
export const STAFF_SESSION_NULL_GRACE_MS = 8000;

export function authLogoutWaitMs(hadStaffSession) {
  if (hadStaffSession) return STAFF_SESSION_NULL_GRACE_MS;
  return loginFallbackDelayMs();
}

export function markGoogleRedirectPending() {
  try {
    sessionStorage.setItem(GOOGLE_REDIRECT_FLAG, '1');
  } catch (_) {
    /* ignore */
  }
}

export function hasGoogleRedirectPending() {
  try {
    return sessionStorage.getItem(GOOGLE_REDIRECT_FLAG) === '1';
  } catch (_) {
    return false;
  }
}

export function consumeGoogleRedirectPending() {
  try {
    const pending = sessionStorage.getItem(GOOGLE_REDIRECT_FLAG) === '1';
    sessionStorage.removeItem(GOOGLE_REDIRECT_FLAG);
    return pending;
  } catch (_) {
    return false;
  }
}
